import React from "react";
import { getApi } from '../../api/endpoints';
import PageUiActionConstants from '../../data/PageUiActionConstants';
import ListingComponent from '../../components/ListingComponent';
import { useParams } from "react-router-dom";

const TransactionDetails = () => {
  const defaultHeaderConfig = { disableSort: true };
  const params = useParams();
  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
      disableSort: false
    },
    {
      ...defaultHeaderConfig,
      label: 'Amount',
      attr: 'amount',
      disableSort: false
    },
    {
      ...defaultHeaderConfig,
      label: 'Transaction For',
      attr: 'transaction_for',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Remarks',
      attr: 'remarks',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Transaction Type',
      attr: 'transaction_type',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Created At',
      attr: 'created_at',
      disableSort: false
    },
  ]

  const filters = { user_id: params.id }

  return <>
    <ListingComponent
      key={PageUiActionConstants.view_customer_transactions.name}
      listingMutation={getApi('walletTransactions')}
      className="customer-transaction-details-listing-page"
      contentHeading="Transaction History - Results"
      headers={headers}
      recordsKey="wallet_transactions"
      filtersModel={ filters }
      searchBy={['ID']}
    />
  </>
};

export default TransactionDetails;
